import React, { useState, useEffect } from "react";
import TimelineEntry from "./TimelineEntry";
import { Link } from "react-router-dom";
import { useLocation } from 'react-router-dom';

// const DownloadButton = ({ src, children }) => {
//     return (
//         <form method="get" action={src}>
//             <button type="submit">{children}</button>
//         </form>
//     )
// }
const CourseInfo = () => {
    const [course, setCourse] = useState(null);
    const locationData = useLocation();

    useEffect(() => {
        if (locationData.state) {
            setCourse(locationData.state.course);
        }
    }, [course])

    if (!locationData.state) return <div className="text-center text-xl mt-8">Invalid page!</div>
    if (!course) return <div className="text-center text-xl mt-8">Loading...</div>
    return (
        <section id="courseInfo" className="font-body">
            <div className="container px-5 py-10 mx-auto text-center lg:px-40">
                <div className="flex flex-col w-full mb-10">
                    <h1 className="sm:text-4xl text-3xl font-medium font-title mb-4">
                        {course.crn}: {course.title}
                    </h1>
                    <h2 className="sm:text-2xl text-2xl font-medium font-title mb-4">
                        {course.subtitle} 
                    </h2>
                    <p className="lg:w-2/3 mx-auto leading-relaxed text-base tracking-wide">
                        {`${course.timeslot}  ·   ${course.location}`}
                    </p>
                    <p className="lg:w-2/3 mx-auto leading-relaxed text-base tracking-wide">
                        {`${course.semester}`}
                    </p>
                    {/* <button className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center w-1/6">
                        <svg className="fill-current w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z" /></svg>
                        <span>Download Syllabus</span>
                    </button> */}
                </div>
                <div className="text-left mb-20 font-body">
                    <p className="font-bold font-title text-3xl mb-4">
                        Links
                    </p>
                    <ul className="list-disc list-inside">
                        <li className="ml-10">
                            <a
                                className="mt-2 hover:text-highlight text-lg underline"
                                href={course.syllabus.link}
                                target="_blank"
                                title="syllabus"> {course.syllabus.name}
                            </a>
                        </li>
                        {course.resources.map((resource, index) => {
                            return (
                                <li key={index} className="ml-10">
                                    <a
                                        className="mt-2 hover:text-highlight text-lg underline"
                                        href={resource.link}
                                        target="_blank"
                                        title="syllabus"> {resource.name}
                                    </a>
                                </li>
                            );
                        })}
                        <li className="ml-10">
                            <span className="hover:text-highlight text-lg underline">
                                <Link
                                    to={{
                                        pathname: `/courseMaterials`,
                                        state: { course }
                                    }}>
                                    Course Materials
                                </Link>
                            </span>
                        </li>
                    </ul>
                </div>

                <div className="container mx-auto w-full h-full font-body">
                    <p className="font-title text-xl font-bold mb-4">Weekly Course Schedule</p>
                    <div className="relative wrap overflow-hidden p-10 h-full border-2 rounded-lg border-gray-200 bg-gray-100">
                        <div className="border-2-2 absolute border-opacity-20 border-gray-700 h-full border" style={{ left: `50%` }}></div>
                        {course.calendar.map((week, index) => {
                            if (index % 2 == 0) {
                                return <TimelineEntry key={index} week={week} direction={"left"} />
                            }
                            else {
                                return <TimelineEntry key={index} week={week} direction={"right"} />
                            }
                        })}
                    </div>
                </div>
            </div>
        </section >
    );
}
export default CourseInfo;


// WEBPACK FOOTER //
// ./src/components/CourseInfo.jsx